import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export { RequestError, isRequestError } from './errors';
export { isRateLimitedError, createRequestErrorReason } from './helpers';
import { createUrl, fetchRetry, createProcessFetchResponse, extendHeaders, isFetchNetworkError, defaultShouldRetryError } from './helpers';
import { fg } from '@atlaskit/platform-feature-flags';
import { mapRetryUrlToPathBasedUrl } from '../pathBasedUrl';
import getNavigator from '../getNavigator';
export function request(_x) {
  return _request.apply(this, arguments);
}
function _request() {
  _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url) {
    var options,
      controller,
      _options$method,
      method,
      endpoint,
      auth,
      params,
      headers,
      body,
      _options$clientOption,
      clientOptions,
      traceContext,
      retryOptions,
      metadata,
      doFetch,
      shouldRetryError,
      _getNavigator2,
      doFetchWithPathBasedUrl,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
          controller = _args.length > 2 ? _args[2] : undefined;
          _options$method = options.method, method = _options$method === void 0 ? 'GET' : _options$method, endpoint = options.endpoint, auth = options.auth, params = options.params, headers = options.headers, body = options.body, _options$clientOption = options.clientOptions, clientOptions = _options$clientOption === void 0 ? {} : _options$clientOption, traceContext = options.traceContext;
          retryOptions = clientOptions.retryOptions;
          metadata = {
            method: method,
            endpoint: endpoint,
            traceContext: traceContext
          }; // TODO BMPT-918: add client timeout feature behing a FF (using clientOptions.clientTimeout + Promise.race)
          doFetch = function doFetch() {
            return fetch(createUrl(url, {
              params: params
            }), {
              method: method,
              body: body,
              headers: extendHeaders(headers, auth, traceContext),
              signal: controller && controller.signal
            }).then(createProcessFetchResponse(metadata));
          };
          if (!fg('platform_media_retry_edge_error')) {
            _context.next = 20;
            break;
          }
          shouldRetryError = function shouldRetryError(err) {
            var _getNavigator;
            if (isFetchNetworkError(err) && (_getNavigator = getNavigator()) !== null && _getNavigator !== void 0 && _getNavigator.userAgent.includes('Edg/')) {
              return false;
            }
            return defaultShouldRetryError(err);
          };
          _context.prev = 8;
          _context.next = 11;
          return fetchRetry(doFetch, metadata, _objectSpread(_objectSpread({}, retryOptions), {}, {
            shouldRetryError: shouldRetryError
          }));
        case 11:
          return _context.abrupt("return", _context.sent);
        case 14:
          _context.prev = 14;
          _context.t0 = _context["catch"](8);
          if (!(isFetchNetworkError(_context.t0) && (_getNavigator2 = getNavigator()) !== null && _getNavigator2 !== void 0 && _getNavigator2.userAgent.includes('Edg/'))) {
            _context.next = 19;
            break;
          }
          doFetchWithPathBasedUrl = function doFetchWithPathBasedUrl() {
            return fetch(createUrl(mapRetryUrlToPathBasedUrl(url).toString(), {
              params: params
            }), {
              method: method,
              body: body,
              headers: extendHeaders(headers, auth, traceContext),
              signal: controller && controller.signal
            }).then(createProcessFetchResponse(metadata));
          };
          return _context.abrupt("return", fetchRetry(doFetchWithPathBasedUrl, metadata, retryOptions));
        case 19:
          throw _context.t0;
        case 20:
          return _context.abrupt("return", fetchRetry(doFetch, metadata, retryOptions));
        case 21:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[8, 14]]);
  }));
  return _request.apply(this, arguments);
}